export default __webpack_public_path__ + "static/media/modal-img.3516fa06.svg";